<template>
    <div >
            <b-button class="BTNzoom"
                      size="is-small"
                      @click="scaleTo(1)">RESET</b-button>
            <b-button class="BTNzoom"
                      size="is-small"
                      icon-left="search-minus"
                      @click="scalePlus"></b-button>
            <b-button class="BTNzoom"
                      size="is-small"
                      icon-left="search-plus"
                      @click="scaleMoins"></b-button>
            <b-button class="BTNzoom"
                      size="is-small"
                      icon-left="times"
                      @click="scaleTo(0.5)">2</b-button>
        <b-button class="BTNzoom"
                  size="is-small is-warning"
                  icon-left="save"
                  @click="exportIt">ENREGISTRER SOUS</b-button>
        <b-button class="BTNzoom"
                  size="is-small is-warning"
                  icon-left="save"
                  @click="saveImage">SCREENSHOT</b-button>


        <b-button class="BTNzoom"
                  size="is-small"
                  icon-left="question"
                  @click="showHelp">AIDE</b-button>

    </div>
</template>

<script>

    import { saveAs } from 'file-saver';

    import _ from 'lodash';

    // La barre de zoom est reliee à la variable "scale" dans le store
    // Le graph ecoute cette variable

    export default {

        computed:{
            getScale () {
                return Math.round(this.$store.getters.getScale * 100) / 100;
            }
        },
        methods: {
            scaleMoins() {

                this.$store.commit('SCALE_CHANGE',0.1);
                this.$notification.open('ZOOM '+this.getScale)
            },
            scalePlus() {

                this.$store.commit('SCALE_CHANGE',-0.1);
                this.$notification.open('ZOOM '+this.getScale)
            },
            scaleTo(val)
            {
                this.$store.commit('SCALE_SET',val);
                this.$notification.open('ZOOM '+this.getScale)
            },
            showHelp(evt){
                const toEdit={
                    name:'TabHelp',
                    config:''
                }
                this.$store.commit('DROITE_SET',toEdit);
            },
            async exportIt(){

                    const blob = await this.$mydb.do.download();
                    if(blob){

                        let fichier="ScenarFab"

                        this.$dialog.prompt({
                            message: `Nom de fichier ?`,
                            confirmText: 'Enregistrer',
                            inputAttrs: {
                                placeholder: 'Indiquez un nom',

                            },
                            onConfirm: (value) => {

                                if(value)
                                    fichier=_.kebabCase(value)
                                const toExport = new Blob([blob], {type: "application/json"});
                                saveAs(toExport, value+".json" );
                            }
                        })


                    }
            },


            // On ajoute un rectangle blanc en background qu'on retire immédiatement
            saveImage(){

                const stage=this.$parent.$refs.stage.getStage()
                var stageRect =  new Konva.Rect({
                    x: -stage.x()/ stage.scaleX(),
                    y: -stage.y()/ stage.scaleY(),
                    width: stage.width() / stage.scaleX(),
                    height: stage.height() / stage.scaleY(),
                    fill: 'white',
                })
               console.log(stage)
                const backg=new Konva.Layer();
                backg.add(stageRect)
                stage.add(backg)
                backg.setZIndex(0)
                const dataURL = stage.toDataURL({ pixelRatio: 1, mimeType:"image/png" });
                backg.destroy();
                this.downloadURI(dataURL, 'stage.png');

            },

            downloadURI(uri, name) {
                let link = document.createElement('a');
                link.download = name;
                link.href = uri;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                //delete link;
            }
        }
    }
</script>


<style lang="scss">

    .BTNzoom{
        margin:2px ;
    }

</style>